import { useContext } from "react";
import { LayoutCellContext } from "../ReactPageLayout/LayoutCellContext";
/**
 * Looks for a cell in the layout that matches the predicate
 * @param predicate
 * @returns
 */
export function useFindLayoutCell(predicate) {
    const node = useContext(LayoutCellContext);
    const attributeNodes = findInLayoutCell(node, predicate, 0);
    return attributeNodes[0];
}
/**
 * Looks for multiple cell in the layout that match the predicate in the current layout cell subtree
 * @param predicate
 * @returns
 */
export function useFindLayoutCells(predicate) {
    const node = useContext(LayoutCellContext);
    const attributeNodes = findInLayoutCell(node, predicate, 0);
    return attributeNodes;
}
/**
 * Find layout cells in the current layout cell subtree
 * @returns A function for finding layout cells
 */
export function useLayoutCellsFinder() {
    const node = useContext(LayoutCellContext);
    return (predicate) => findInLayoutCell(node, predicate, 0);
}
/**
 * Find cell in cell subtree
 * @param cell
 * @param activeAttributeId
 * @param depth Lookup depth
 * @returns
 */
export function findInLayoutCell(cell, predicate, depth = 0) {
    const cells = [];
    if (predicate(cell, depth)) {
        cells.push(cell);
    }
    if (cell.rows) {
        // find the first cell
        for (const row of cell.rows) {
            const tabCells = findInLayoutRow(row, predicate, depth + 1);
            if (tabCells) {
                cells.push(...tabCells);
            }
        }
    }
    return cells;
}
/**
 *  Find cell in row
 * @param row
 * @param activeAttributeId
 * @param depth Lookup depth
 * @returns
 */
export function findInLayoutRow(row, predicate, depth = 0) {
    return row.cells.reduce((cells, cell) => [...cells, ...findInLayoutCell(cell, predicate, depth)], []);
}
//# sourceMappingURL=useFindLayoutCell.js.map